import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteRechnungsVorlageCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteRechnungsVorlageCommandService],
  exports: []
})
export class DeleteRechnungsVorlageCommandServiceModule { }
